import { render, staticRenderFns } from "./BaixaItemBemPermanenteList.vue?vue&type=template&id=0e5333c5"
import script from "./BaixaItemBemPermanenteList.vue?vue&type=script&lang=js"
export * from "./BaixaItemBemPermanenteList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports